// Names of Allah - Daily Rotation
export const namesOfAllah = [
	{
		id: 1,
		arabic: "الرَّحْمَنُ",
		transliteration: "Ar-Rahman",
		meaning: "The Most Merciful",
		detailedMeaning: "Ar-Rahman encompasses Allah's vast and all-encompassing mercy that extends to all of creation. His mercy is boundless and comes before His justice. In moments of struggle, remembering His mercy reminds us that Allah cares for us and desires our well-being.",
		reflection: "How can I show mercy to myself today after a struggle?",
	},
	{
		id: 2,
		arabic: "الرَّحِيمُ",
		transliteration: "Ar-Raheem",
		meaning: "The Bestower of Mercy",
		detailedMeaning: "While Ar-Rahman is Allah's general mercy, Ar-Raheem is His specific mercy towards the believing servants who seek His compassion. He is merciful and kind to those who turn to Him in their weakness.",
		reflection: "Reflect on a moment of compassion you received when you least expected it.",
	},
	{
		id: 3,
		arabic: "الْغَفَّارُ",
		transliteration: "Al-Ghaffar",
		meaning: "The Repeatedly Forgiving",
		detailedMeaning: "Al-Ghaffar is the One who forgives repeatedly without tiring or holding grudges. The 'Fa' at the beginning emphasizes the frequency of His forgiveness. No matter how many times we slip, Allah's door of repentance is always open.",
		reflection: "Allah forgives again and again. Do I have the courage to ask again?",
	},
	{
		id: 4,
		arabic: "الرَّقِيبُ",
		transliteration: "Al-Raqib",
		meaning: "The All-Watchful",
		detailedMeaning: "Al-Raqib sees and observes all things with perfect knowledge. He witnesses not just our actions, but our intentions and efforts. The beauty is that He sees when we struggle against temptation and counts these as good deeds.",
		reflection: "He sees the effort I make to resist, not just the moments I slip.",
	},
	{
		id: 5,
		arabic: "الْقَوِيُّ",
		transliteration: "Al-Qawwiyy",
		meaning: "The All-Strong",
		detailedMeaning: "Al-Qawwiyy is the source of all strength and power. When we feel powerless against our desires, we can turn to The Strong and ask for His strength. Our weakness becomes a doorway to His strength.",
		reflection: "When I feel weak against my routine, can I ask The Strong for His strength?",
	},
	{
		id: 6,
		arabic: "الْفَتَّاحُ",
		transliteration: "Al-Fattah",
		meaning: "The Opener",
		detailedMeaning: "Al-Fattah opens the doors of guidance, victory, and solutions. When we feel trapped by our habits, He can open a way out that we cannot see. He opens the hearts of people and the paths to success.",
		reflection: "Ya Fattah, open a door for me out of this habit that I cannot see yet.",
	},
	{
		id: 7,
		arabic: "الْوَدُودُ",
		transliteration: "Al-Wadud",
		meaning: "The Most Loving",
		detailedMeaning: "Al-Wadud is the Most Loving. His love for the repentant and the sincere is beyond measure. He loves those who turn back to Him despite their failures, and His love becomes a source of healing.",
		reflection: "Allah's love for the repentant is greater than the weight of the sin.",
	},
	{
		id: 8,
		arabic: "الْمُؤْمِنُ",
		transliteration: "Al-Mu'min",
		meaning: "The Giver of Security",
		detailedMeaning: "Al-Mu'min provides true security and peace. While worldly distractions may temporarily soothe our anxiety, true peace comes only from relying on Allah. His protection and security are the ultimate refuge.",
		reflection: "Where do I seek safety when I am stressed? Is it in my habit or in Him?",
	},
	{
		id: 9,
		arabic: "الْحَلِيمُ",
		transliteration: "Al-Haleem",
		meaning: "The Most Forbearing",
		detailedMeaning: "Al-Haleem is the Most Patient and Forbearing. He doesn't rush to punish despite our repeated mistakes. His patience teaches us that healing is a journey, and every step counts.",
		reflection: "He is patient with my repeated mistakes. How can I be patient with my growth?",
	},
	{
		id: 10,
		arabic: "الْعَلِيمُ",
		transliteration: "Al-Aleem",
		meaning: "The All-Knowing",
		detailedMeaning: "Al-Aleem knows all things—past, present, and future. He knows why we struggle before we even realize it ourselves. This knowledge is a comfort: we don't have to hide our struggles from Him, and He already knows the best way for us.",
		reflection: "He already knows my struggles better than I do. Can I trust His wisdom?",
	},
];

/**
 * Get daily Name of Allah based on current date
 * Rotates through 10 names, changing daily
 */
export function getDailyName(date = new Date()) {
	const idx = date.getDate() % namesOfAllah.length;
	return namesOfAllah[idx];
}
